export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><path d=\"M13.522 3.316a6.438 6.438 0 00-4.7-2.013c-3.238 0-6.009 2.424-6.444 5.638a5.597 5.597 0 00-.044.793L.816 6.586l-.41.542 2.131 1.61a.338.338 0 00.424-.01l1.992-1.683-.437-.519-1.498 1.265a5.007 5.007 0 01.037-.758c.389-2.878 2.869-5.048 5.768-5.048 1.603 0 3.097.64 4.206 1.802a5.808 5.808 0 011.609 4.321c-.14 2.998-2.691 5.491-5.685 5.556a5.821 5.821 0 01-5.09-2.78l-.581.358a6.486 6.486 0 005.686 3.104c3.402-.074 6.192-2.8 6.352-6.206a6.487 6.487 0 00-1.798-4.824z\" fill=\"#3F4450\" fill-rule=\"nonzero\" stroke=\"#3F4450\" stroke-width=\".4\"/></g>",
  "attrs": {
    "height": "16",
    "viewBox": "0 0 16 16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};